import { render, staticRenderFns } from "./jz.vue?vue&type=template&id=0e345fdf&scoped=true"
var script = {}
import style0 from "./jz.vue?vue&type=style&index=0&id=0e345fdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e345fdf",
  null
  
)

export default component.exports